/*
 * @Author: Tahiti
 * @Date: 2025-12-03 15:01:29
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 22:32:59
 * @Description:
 * @FilePath: /weryai-web/locales/modules/order_modal.ts
 */
export default {
    zh: {
        change_plan: '更换套餐',
        choose_order_type: '选择支付方式',
        credit_card: '信用卡',
        card_notice: '除非另有标记，否则所有字段均为必填项。',
        card_number: '卡号',
        expiry_date: '有效期',
        cvv: '安全码',
        cardholder_name: '持卡人姓名',
        cardholder_name_notice: '请输入持卡人姓名',
        pay_now: '支付',
        processing: '处理中...',
        account: '账号',
        product_name: '产品名称',
        paymentInformationIsSafe: '您的支付信息是安全的',
        cancelSubscription: '您可以随时取消订阅',
        pay_type_loading: '支付方式加载中...',
        order_content: '待支付订单',
        pending_order_title: '你有一笔订单待支付',
        pending_order_subtitle:
            '请在<span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>内支付,超时自动取消',
        product: '商品:',
        original_price: '原价:',
        now_price: '现价:',
        purchase_method: '购买方式:',
        cancel: '取消',
        continue_pay: '继续支付',
        year_pay: '年度',
        monthly_pay: '月度',
        year_price: '/年',
        payment_information_is_safe: '微鲤AI 致力于保护您的支付安全',
        go_to_create: '去创作',
        continue_chat: '继续聊天',
        pay_success: '支付成功',
        pay_failed: '无法处理扣款',
        pay_failed_notice: '请尝试其他卡或使用其他支付方式',
        change_payment_method: '更换支付方式',
        pending_order_content: '待支付订单',
        expiry_date_placeholder: '月/年',
        paypal: 'Paypal',
        bank_card_pay: '银行卡支付',
        errorVideoUpscalerSizeExceeded: '视频大小不能超过100MB',
        videoUpscalerResolutionTooLow:
            '所选分辨率{target}不能小于原视频分辨率{source}',
        first_pay_half_price: '🎉首次订阅会员生成享半价折扣',
        current_order: '当前订阅',
        expiry_time: '到期时间',
        monthly: '月付',
        yearly: '年付',
        order_query_failed: '订单查询失败，',
        order_query_failed_button: '点击重新查询',
        short_pay_type: '快捷支付',
        or: '或者',
        month_half_price:'首次订阅赠送前1次生成立享5折优惠',
        year_half_price:'首次订阅赠送前5次生成立享5折优惠',
        shop:'商城',
        right_now_login: '立即登录',
        login_to_use_more_features: '登录使用更多功能',
    },
    en: {
        change_plan: 'Change Plan',
        choose_order_type: 'Choose Order Type',
        credit_card: 'Credit Card',
        card_notice: 'All fields are required unless otherwise indicated.',
        card_number: 'Card Number',
        expiry_date: 'Expiry Date',
        cvv: 'CVV',
        cardholder_name: 'Cardholder Name',
        cardholder_name_notice: 'Please enter the cardholder name',
        pay_now: 'Pay Now',
        processing: 'Processing...',
        account: 'Account',
        product_name: 'Product Name',
        paymentInformationIsSafe: 'Your payment information is safe',
        cancelSubscription: 'You can cancel your subscription at any time',
        pay_type_loading: 'Payment type loading...',
        order_content: 'Pending Payment Order',
        pending_order_title: 'You have an order pending payment',
        pending_order_subtitle:
            'Please pay within <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, it will be automatically canceled if overdue',
        product: 'Product:',
        original_price: 'Original Price:',
        now_price: 'Now Price:',
        purchase_method: 'Purchase Method:',
        cancel: 'Cancel',
        continue_pay: 'Continue Payment',
        year_pay: 'Yearly',
        monthly_pay: 'Monthly',
        year_price: '/Year',
        payment_information_is_safe:
            '微鲤AI is committed to protecting your payment security',
        go_to_create: 'Go to Create',
        continue_chat: 'Continue Chat',
        pay_success: 'Payment Success',
        pay_failed: 'Unable to process payment',
        pay_failed_notice:
            'Please try another card or use another payment method',
        change_payment_method: 'Change Payment Method',
        pending_order_content: 'Pending Payment Order',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Bank Card Pay',
        errorVideoUpscalerSizeExceeded: 'Video size cannot exceed 100MB',
        videoUpscalerResolutionTooLow:
            'The selected resolution {target} cannot be less than the original video resolution {source}',
        first_pay_half_price:
            '🎉 50% off generations for first-time subscribers',
        current_order: 'Current subscription',
        expiry_time: 'Expiration date',
        monthly: 'Monthly',
        yearly: 'Yearly',
        order_query_failed: 'Order query failed,',
        order_query_failed_button: 'Click to re-query',
        short_pay_type: 'Express Pay',
        or: 'or',
        month_half_price: 'Enjoy 50% off on your first generation with first subscription',
        year_half_price: 'Enjoy 50% off on your first 5 generations with first subscription',
        shop:'Shop',
        right_now_login: 'Log in now',
        login_to_use_more_features: 'Log in to use more features',
    },
    ja: {
        change_plan: 'プランを変更',
        choose_order_type: '支払い方法を選択',
        credit_card: 'クレジットカード',
        card_notice: 'すべてのフィールドは、特に指示がない限り必須です。',
        card_number: 'カード番号',
        expiry_date: '有効期限',
        cvv: 'セキュリティコード',
        cardholder_name: 'カード保有者名',
        cardholder_name_notice: 'カード保有者名を入力してください',
        pay_now: '今すぐ支払う',
        processing: '処理中...',
        account: 'アカウント',
        product_name: '商品名',
        paymentInformationIsSafe: 'あなたの支払い情報は安全です',
        cancelSubscription: 'いつでもサブスクリプションを解除できます',
        pay_type_loading: '支払い方法の読み込み中...',
        order_content: '待機中の支払い注文',
        pending_order_title: '支払い待ちの注文があります',
        pending_order_subtitle:
            '<span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>以内に支払ってください。期限切れの場合は自動的にキャンセルされます',
        product: '商品:',
        original_price: '原価:',
        now_price: '現価:',
        purchase_method: '購入方法:',
        cancel: 'キャンセル',
        continue_pay: '支払いを続ける',
        year_pay: '年額',
        monthly_pay: '月額',
        year_price: '/年',
        payment_information_is_safe:
            'WeryAIはあなたの支払いセキュリティを保護することにコミットしています',
        go_to_create: '作成に行く',
        continue_chat: 'チャットを続ける',
        pay_success: '支払い成功',
        pay_failed: '支払い処理ができません',
        pay_failed_notice:
            '他のカードを試してください、または他の支払い方法を使用してください',
        change_payment_method: '支払い方法を変更',
        pending_order_content: '待機中の支払い注文',
        expiry_date_placeholder: '月/年',
        paypal: 'Paypal',
        bank_card_pay: '銀行カード支払い',
        errorVideoUpscalerSizeExceeded:
            'ビデオサイズは100MBを超えることはできません',
        videoUpscalerResolutionTooLow:
            '選択された解像度{target}は、元のビデオ解像度{source}よりも小さくすることはできません',
        first_pay_half_price: '🎉 初回サブスク登録で生成が半額',
        current_order: '現在のサブスクリプション',
        expiry_time: '有効期限',
        monthly: '月払い',
        yearly: '年払い',
        order_query_failed: '주문 조회 실패,',
        order_query_failed_button: '클릭하여 다시 조회',
        short_pay_type: 'クイック支払い',
        or: 'または',
        month_half_price: '初回サブスク登録で最初の1回生成が50%オフ',
        year_half_price: '初回サブスク登録で最初の5回生成が50%オフ',
        shop: 'ショップ',
        right_now_login: '今すぐログイン',
        login_to_use_more_features: 'ログインしてより多くの機能を利用',
    },
    ko: {
        change_plan: '플랜 변경',
        choose_order_type: '결제 방법 선택',
        credit_card: '신용 카드',
        card_notice: '특별히 표시되지 않는 한 모든 필드는 필수입니다.',
        card_number: '카드 번호',
        expiry_date: '만료 일',
        cvv: '보안코드',
        cardholder_name: '카드 소유자 이름',
        cardholder_name_notice: '카드 소유자 이름을 입력해주세요',
        pay_now: '지금 결제',
        processing: '처리 중...',
        account: '계정',
        product_name: '제품 이름',
        paymentInformationIsSafe: '결제 정보는 안전합니다',
        cancelSubscription: '언제든지 구독을 해지할 수 있습니다',
        pay_type_loading: '결제 방법 로딩 중...',
        order_content: '대기 중인 결제 주문',
        pending_order_title: '결제 대기 중인 주문이 있습니다',
        pending_order_subtitle:
            '<span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span> 내에 결제해 주세요. 시간 초과 시 자동으로 취소됩니다',
        product: '상품:',
        original_price: '원가:',
        now_price: '현가:',
        purchase_method: '구매 방법:',
        cancel: '취소',
        continue_pay: '결제 계속하기',
        year_pay: '연간',
        monthly_pay: '월額',
        year_price: '/년',
        payment_information_is_safe:
            'WeryAI는 당신의 결제 보안을 보호하기 위해 커밋하고 있습니다',
        go_to_create: '창작으로 이동',
        continue_chat: '채팅 계속하기',
        pay_success: '결제 성공',
        pay_failed: '결제 처리 불가',
        pay_failed_notice: '다른 카드를 시도하거나 다른 결제 방법을 사용하세요',
        change_payment_method: '결제 방법 변경',
        pending_order_content: '대기 중인 결제 주문',
        expiry_date_placeholder: '월/년',
        paypal: 'Paypal',
        bank_card_pay: '은행 카드 결제',
        errorVideoUpscalerSizeExceeded:
            '비디오 크기는 100MB를 초과할 수 없습니다',
        videoUpscalerResolutionTooLow:
            '선택된 해상도 {target}는 원본 비디오 해상도 {source}보다 작을 수 없습니다',
        first_pay_half_price: '🎉 첫 구독 시 생성 50% 할인',
        current_order: '현재 구독',
        expiry_time: '만료일',
        monthly: '월간',
        yearly: '연간',
        short_pay_type: '간편 결제',
        or: '또는',
        month_half_price: '첫 구독 시 첫 1회 생성 50% 할인',
        year_half_price: '첫 구독 시 첫 5회 생성 50% 할인',
        shop: '상점',
        right_now_login: '지금 로그인',
        login_to_use_more_features: '로그인하여 더 많은 기능 사용',
    },
    tw: {
        change_plan: '更换套餐',
        choose_order_type: '选择支付方式',
        credit_card: '信用卡',
        card_notice: '除非另有标记，否则所有字段均为必填项。',
        card_number: '卡号',
        expiry_date: '有效期',
        cvv: '安全码',
        cardholder_name: '持卡人姓名',
        cardholder_name_notice: '请输入持卡人姓名',
        pay_now: '支付',
        processing: '处理中...',
        account: '账号',
        product_name: '产品名称',
        paymentInformationIsSafe: '您的支付信息是安全的',
        cancelSubscription: '您可以随时取消订阅',
        pay_type_loading: '支付方式加载中...',
        order_content: '待支付订单',
        pending_order_title: '你有一笔订单待支付',
        pending_order_subtitle:
            '请在<span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>内支付,超时自动取消',
        product: '商品:',
        original_price: '原价:',
        now_price: '现价:',
        purchase_method: '购买方式:',
        cancel: '取消',
        continue_pay: '继续支付',
        year_pay: '年度',
        monthly_pay: '月度',
        year_price: '/年',
        payment_information_is_safe: '微鲤AI 致力于保护您的支付安全',
        go_to_create: '去创作',
        continue_chat: '继续聊天',
        pay_success: '支付成功',
        pay_failed: '无法处理扣款',
        pay_failed_notice: '请尝试其他卡或使用其他支付方式',
        change_payment_method: '更换支付方式',
        pending_order_content: '待支付订单',
        expiry_date_placeholder: '月/年',
        paypal: 'Paypal',
        bank_card_pay: '银行卡支付',
        errorVideoUpscalerSizeExceeded: '视频大小不能超过100MB',
        videoUpscalerResolutionTooLow:
            '所选分辨率{target}不能小于原视频分辨率{source}',
        first_pay_half_price: '🎉首次訂閱會員生成享半價折扣',
        current_order: '當前訂閱',
        expiry_time: '到期時間',
        monthly: '月付',
        yearly: '年付',
        order_query_failed: '訂單查詢失敗，',
        order_query_failed_button: '點擊重新查詢',
        short_pay_type: '快捷支付',
        or: '或者',
        month_half_price: '首次訂閱贈送前1次生成立享5折優惠',
        year_half_price: '首次訂閱贈送前5次生成立享5折優惠',
        shop:'商城',
        right_now_login: '立即登入',
        login_to_use_more_features: '登入使用更多功能',
    },
    pl: {
        change_plan: 'Change Plan',
        choose_order_type: 'Choose Order Type',
        credit_card: 'Credit Card',
        card_notice: 'All fields are required unless otherwise indicated.',
        card_number: 'Card Number',
        expiry_date: 'Expiry Date',
        cvv: 'CVV',
        cardholder_name: 'Cardholder Name',
        cardholder_name_notice: 'Please enter the cardholder name',
        pay_now: 'Pay Now',
        processing: 'Processing...',
        account: 'Account',
        product_name: 'Product Name',
        paymentInformationIsSafe: 'Your payment information is safe',
        cancelSubscription: 'You can cancel your subscription at any time',
        pay_type_loading: 'Payment type loading...',
        order_content: 'Pending Payment Order',
        pending_order_title: 'You have an order pending payment',
        pending_order_subtitle:
            'Please pay within <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, it will be automatically canceled if overdue',
        product: 'Product:',
        original_price: 'Original Price:',
        now_price: 'Now Price:',
        purchase_method: 'Purchase Method:',
        cancel: 'Cancel',
        continue_pay: 'Continue Payment',
        year_pay: 'Yearly',
        monthly_pay: 'Monthly',
        year_price: '/Year',
        payment_information_is_safe:
            '微鲤AI is committed to protecting your payment security',
        go_to_create: 'Go to Create',
        continue_chat: 'Continue Chat',
        pay_success: 'Payment Success',
        pay_failed: 'Unable to process payment',
        pay_failed_notice:
            'Please try another card or use another payment method',
        change_payment_method: 'Change Payment Method',
        pending_order_content: 'Pending Payment Order',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Bank Card Pay',
        errorVideoUpscalerSizeExceeded: 'Video size cannot exceed 100MB',
        videoUpscalerResolutionTooLow:
            'The selected resolution {target} cannot be less than the original video resolution {source}',
        first_pay_half_price:
            '🎉 50% off generations for first-time subscribers',
        current_order: 'Current subscription',
        expiry_time: 'Expiration date',
        monthly: 'Monthly',
        yearly: 'Yearly',
        order_query_failed: 'Order query failed,',
        order_query_failed_button: 'Click to re-query',
        short_pay_type: 'Szybka płatność',
        or: 'lub',
        month_half_price: 'Enjoy 50% off on your first generation with first subscription',
        year_half_price: 'Enjoy 50% off on your first 5 generations with first subscription',
        shop: 'Sklep',
        right_now_login: 'Zaloguj się teraz',
        login_to_use_more_features: 'Zaloguj się, aby korzystać z większej liczby funkcji',
    },
    es: {
        change_plan: 'Cambiar Plan',
        choose_order_type: 'Elegir Método de Pago',
        credit_card: 'Tarjeta de Crédito',
        card_notice:
            'Todos los campos son obligatorios, excepto se indique lo contrario.',
        card_number: 'Número de Tarjeta',
        expiry_date: 'Fecha de Expiración',
        cvv: 'Código de Seguridad',
        cardholder_name: 'Nombre del Titular de la Tarjeta',
        cardholder_name_notice:
            'Por favor ingrese el nombre del titular de la tarjeta',
        pay_now: 'Pagar Ahora',
        processing: 'Procesando...',
        account: 'Cuenta',
        product_name: 'Nombre del Producto',
        paymentInformationIsSafe: 'Su información de pago es segura',
        cancelSubscription:
            'Puede cancelar su suscripción en cualquier momento',
        pay_type_loading: 'Cargando método de pago...',
        order_content: 'Orden de pago pendiente',
        pending_order_title: 'Tienes una orden pendiente de pago',
        pending_order_subtitle:
            'Por favor paga dentro de <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, se cancelará automáticamente si se vence',
        product: 'Producto:',
        original_price: 'Precio Original:',
        now_price: 'Precio Actual:',
        purchase_method: 'Método de Compra:',
        cancel: 'Cancelar',
        continue_pay: 'Continuar Pago',
        year_pay: 'Anual',
        monthly_pay: 'Mensual',
        year_price: '/Año',
        payment_information_is_safe:
            '微鲤AI se compromete a proteger la seguridad de su pago',
        go_to_create: 'Ir a Crear',
        continue_chat: 'Continuar Chat',
        pay_success: 'Pago Exitoso',
        pay_failed: 'No se puede procesar el pago',
        pay_failed_notice: 'Intente con otra tarjeta o use otro método de pago',
        change_payment_method: 'Cambiar Método de Pago',
        pending_order_content: 'Orden de pago pendiente',
        expiry_date_placeholder: 'MM/AA',
        paypal: 'Paypal',
        bank_card_pay: 'Pago con Tarjeta Bancaria',
        errorVideoUpscalerSizeExceeded:
            'El tamaño del video no puede exceder 100MB',
        videoUpscalerResolutionTooLow:
            'La resolución seleccionada {target} no puede ser menor que la resolución original del video {source}',
        first_pay_half_price:
            '🎉 50% de descuento en generaciones en tu primera suscripción',
        current_order: 'Suscripción actual',
        expiry_time: 'Fecha de vencimiento',
        monthly: 'Mensual',
        yearly: 'Anual',
        order_query_failed: 'Orden de pago fallida,',
        order_query_failed_button: 'Haga clic para volver a consultar',
        short_pay_type: 'Pago rápido',
        or: 'o',
        month_half_price: 'Disfruta 50% de descuento en tu primera generación con la primera suscripción',
        year_half_price: 'Disfruta 50% de descuento en tus primeras 5 generaciones con la primera suscripción',
        shop: 'Tienda',
        right_now_login: 'Iniciar sesión ahora',
        login_to_use_more_features: 'Inicia sesión para usar más funciones',
    },
    fr: {
        change_plan: 'Changer de Plan',
        choose_order_type: 'Choisir le Mode de Paiement',
        credit_card: 'Carte de Crédit',
        card_notice:
            'Tous les champs sont obligatoires, sauf indication contraire.',
        card_number: 'Numéro de Carte',
        expiry_date: "Date d'Expiration",
        cvv: 'Code de Sécurité',
        cardholder_name: 'Nom du Titulaire de la Carte',
        cardholder_name_notice:
            'Veuillez entrer le nom du titulaire de la carte',
        pay_now: 'Payer Maintenant',
        processing: 'En traitement...',
        account: 'Compte',
        product_name: 'Nom du Produit',
        paymentInformationIsSafe: 'Votre information de paiement est sécurisée',
        cancelSubscription:
            'Vous pouvez annuler votre abonnement à tout moment',
        pay_type_loading: 'Chargement du mode de paiement...',
        order_content: 'Commande de paiement en attente',
        pending_order_title: 'Vous avez une commande en attente de paiement',
        pending_order_subtitle:
            'Veuillez payer dans <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, elle sera automatiquement annulée si elle expire',
        product: 'Produit:',
        original_price: 'Prix Original:',
        now_price: 'Prix Actuel:',
        purchase_method: "Méthode d'Achat:",
        cancel: 'Annuler',
        continue_pay: 'Continuer le Paiement',
        year_pay: 'Année',
        monthly_pay: 'Mensuel',
        year_price: '/Année',
        payment_information_is_safe:
            "微鲤AI s'engage à protéger la sécurité de votre paiement",
        go_to_create: 'Aller à Créer',
        continue_chat: 'Continuer le Chat',
        pay_success: 'Paiement Réussi',
        pay_failed: 'Impossible de traiter le paiement',
        pay_failed_notice:
            'Veuillez essayer avec une autre carte ou utiliser un autre mode de paiement',
        change_payment_method: 'Changer le Mode de Paiement',
        pending_order_content: 'Commande de paiement en attente',
        expiry_date_placeholder: 'MM/AA',
        paypal: 'Paypal',
        bank_card_pay: 'Paiement par Carte Bancaire',
        errorVideoUpscalerSizeExceeded:
            'Die Größe des Videos darf 100MB nicht überschreiten',
        videoUpscalerResolutionTooLow:
            'Die ausgewählte Auflösung {target} kann nicht kleiner sein als die ursprüngliche Auflösung des Videos {source}',
        first_pay_half_price:
            '🎉 -50 % sur les générations lors de votre première souscription',
        current_order: 'Abonnement actuel',
        expiry_time: "Date d'expiration",
        monthly: 'Mensuel',
        yearly: 'Annuel',
        order_query_failed: 'Bestellung Abfrage fehlgeschlagen,',
        order_query_failed_button: 'Klicken Sie, um erneut abzufragen',
        short_pay_type: 'Paiement rapide',
        or: 'ou',
        month_half_price: 'Profitez de 50% de réduction sur votre première génération avec votre premier abonnement',
        year_half_price: 'Profitez de 50% de réduction sur vos 5 premières générations avec votre premier abonnement',
        shop: 'Boutique',
        right_now_login: 'Se connecter maintenant',
        login_to_use_more_features: 'Connectez-vous pour utiliser plus de fonctionnalités',
    },
    de: {
        change_plan: 'Plan ändern',
        choose_order_type: 'Zahlungsmethode auswählen',
        credit_card: 'Kreditkarte',
        card_notice:
            'Alle Felder sind obligatorisch, es sei denn, es ist anders angegeben.',
        card_number: 'Kartennummer',
        expiry_date: 'Ablaufdatum',
        cvv: 'Sicherheitscode',
        cardholder_name: 'Name des Karteninhabers',
        cardholder_name_notice:
            'Bitte geben Sie den Namen des Karteninhabers ein',
        pay_now: 'Jetzt Bezahlen',
        processing: 'Wird verarbeitet...',
        account: 'Konto',
        product_name: 'Produktname',
        paymentInformationIsSafe: 'Ihre Zahlungsinformationen sind sicher',
        cancelSubscription: 'Sie können Ihr Abonnement jederzeit stornieren',
        pay_type_loading: 'Zahlungsmethode wird geladen...',
        order_content: 'Ausstehende Zahlungsanfrage',
        pending_order_title: 'Sie haben eine ausstehende Zahlungsbestellung',
        pending_order_subtitle:
            'Bitte zahlen Sie innerhalb von <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, sie wird automatisch storniert, wenn sie abläuft',
        product: 'Produkt:',
        original_price: 'Ursprünglicher Preis:',
        now_price: 'Aktueller Preis:',
        purchase_method: 'Kaufmethode:',
        cancel: 'Abbrechen',
        continue_pay: 'Zahlung Fortsetzen',
        year_pay: 'Jahr',
        monthly_pay: 'Monat',
        year_price: '/Jahr',
        payment_information_is_safe:
            '微鲤AI ist sich der Sicherheit Ihres Zahlungsinformations bewusst',
        go_to_create: 'Zu Erstellen',
        continue_chat: 'Chat Fortsetzen',
        pay_success: 'Zahlung erfolgreich',
        pay_failed: 'Zahlung kann nicht verarbeitet werden',
        pay_failed_notice:
            'Bitte versuchen Sie mit einer anderen Karte oder verwenden Sie einen anderen Zahlungsmethode',
        change_payment_method: 'Zahlungsmethode ändern',
        pending_order_content: 'Ausstehende Zahlungsanfrage',
        expiry_date_placeholder: 'MM/JJ',
        paypal: 'Paypal',
        bank_card_pay: 'Bankkartenzahlung',
        errorVideoUpscalerSizeExceeded: 'Размер видео не может превышать 100MB',
        videoUpscalerResolutionTooLow:
            'Выбранное разрешение {target} не может быть меньше исходного разрешения видео {source}',
        first_pay_half_price:
            '🎉 50 % Rabatt auf Generierungen bei der ersten Mitgliedschaft',
        current_order: 'Aktuelles Abonnement',
        expiry_time: 'Ablaufdatum',
        monthly: 'Monatlich',
        yearly: 'Jährlich',
        order_query_failed: 'Bestellung Abfrage fehlgeschlagen,',
        order_query_failed_button: 'Klicken Sie, um erneut abzufragen',
        short_pay_type: 'Schnellzahlung',
        or: 'oder',
        month_half_price: '50% Rabatt auf Ihre erste Generierung bei Erstabonnement',
        year_half_price: '50% Rabatt auf Ihre ersten 5 Generierungen bei Erstabonnement',
        shop: 'Geschäft',
        right_now_login: 'Jetzt anmelden',
        login_to_use_more_features: 'Anmelden, um mehr Funktionen zu nutzen',
    },
    ru: {
        change_plan: 'Изменить План',
        choose_order_type: 'Выбрать Способ Оплаты',
        credit_card: 'Кредитная Карта',
        card_notice: 'Все поля обязательны, за исключением указанных иначе.',
        card_number: 'Номер Карты',
        expiry_date: 'Дата Истечения',
        cvv: 'Код Безопасности',
        cardholder_name: 'Имя Владельца Карты',
        cardholder_name_notice: 'Пожалуйста, введите имя владельца карты',
        pay_now: 'Оплатить Сейчас',
        processing: 'Обработка...',
        account: 'Аккаунт',
        product_name: 'Название Продукта',
        paymentInformationIsSafe: 'Ваша информация о платеже безопасна',
        cancelSubscription: 'Вы можете отменить свою подписку в любое время',
        pay_type_loading: 'Загрузка способа оплаты...',
        order_content: 'Ожидающий платеж',
        pending_order_title: 'У вас есть заказ, ожидающий оплаты',
        pending_order_subtitle:
            'Пожалуйста, оплатите в течение <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, он будет автоматически отменен при истечении срока',
        product: 'Товар:',
        original_price: 'Исходная Цена:',
        now_price: 'Текущая Цена:',
        purchase_method: 'Способ Покупки:',
        cancel: 'Отменить',
        continue_pay: 'Продолжить Оплату',
        year_pay: 'Год',
        monthly_pay: 'Месяц',
        year_price: '/Год',
        payment_information_is_safe:
            '微鲤AI стремится защитить безопасность вашего платежа',
        go_to_create: 'Перейти к созданию',
        continue_chat: 'Продолжить Чат',
        pay_success: 'Платеж успешно выполнен',
        pay_failed: 'Не удалось обработать платеж',
        pay_failed_notice:
            'Пожалуйста, попробуйте другую карту или используйте другой метод оплаты',
        change_payment_method: 'Изменить метод оплаты',
        pending_order_content: 'Ожидающий платеж',
        expiry_date_placeholder: 'ММ/ГГ',
        paypal: 'Paypal',
        bank_card_pay: 'Оплата Банковской Картой',
        errorVideoUpscalerSizeExceeded: 'Размер видео не может превышать 100MB',
        videoUpscalerResolutionTooLow:
            'Выбранное разрешение {target} не может быть меньше исходного разрешения видео {source}',
        first_pay_half_price: '🎉 Скидка 50% на генерацию при первой подписке',
        current_order: 'Текущая подписка',
        expiry_time: 'Дата окончания',
        monthly: 'Ежемесячно',
        yearly: 'Ежегодно',
        order_query_failed: 'Заказ запроса не выполнен,',
        order_query_failed_button: 'Нажмите, чтобы снова запросить',
        short_pay_type: 'Быстрая оплата',
        or: 'или',
        month_half_price: 'Скидка 50% на первую генерацию при первой подписке',
        year_half_price: 'Скидка 50% на первые 5 генераций при первой подписке',
        shop: 'Магазин',
        right_now_login: 'Войти сейчас',
        login_to_use_more_features: 'Войдите, чтобы использовать больше функций',
    },
    pt: {
        change_plan: 'Alterar Plano',
        choose_order_type: 'Escolher Método de Pagamento',
        credit_card: 'Cartão de Crédito',
        card_notice:
            'Todos os campos são obrigatórios, exceto se indicado o contrário.',
        card_number: 'Número do Cartão',
        expiry_date: 'Data de Expiração',
        cvv: 'Código de Segurança',
        cardholder_name: 'Nome do Titular do Cartão',
        cardholder_name_notice:
            'Por favor, entre com o nome do titular do cartão',
        pay_now: 'Pagar Agora',
        processing: 'Processando...',
        account: 'Conta',
        product_name: 'Nome do Produto',
        paymentInformationIsSafe: 'Sua informação de pagamento é segura',
        cancelSubscription:
            'Você pode cancelar sua assinatura a qualquer momento',
        pay_type_loading: 'Carregando método de pagamento...',
        order_content: 'Pedido de pagamento pendente',
        pending_order_title: 'Você tem um pedido pendente de pagamento',
        pending_order_subtitle:
            'Por favor, pague dentro de <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, será cancelado automaticamente se expirar',
        product: 'Produto:',
        original_price: 'Preço Original:',
        now_price: 'Preço Atual:',
        purchase_method: 'Método de Compra:',
        cancel: 'Cancelar',
        continue_pay: 'Continuar Pagamento',
        year_pay: 'Ano',
        monthly_pay: 'Mês',
        year_price: '/Ano',
        payment_information_is_safe:
            '微鲤AI se compromete a proteger a segurança de seu pagamento',
        go_to_create: 'Ir para Criar',
        continue_chat: 'Continuar Chat',
        pay_success: 'Pagamento Feito',
        pay_failed: 'Não é possível processar o pagamento',
        pay_failed_notice:
            'Por favor, tente com outra carta ou use outro método de pagamento',
        change_payment_method: 'Mudar Método de Pagamento',
        pending_order_content: 'Pedido de pagamento pendente',
        expiry_date_placeholder: 'MM/AA',
        paypal: 'Paypal',
        bank_card_pay: 'Pagamento com Cartão Bancário',
        errorVideoUpscalerSizeExceeded:
            'O tamanho do vídeo não pode exceder 100MB',
        videoUpscalerResolutionTooLow:
            'A resolução selecionada {target} não pode ser menor que a resolução original do vídeo {source}',
        first_pay_half_price:
            '🎉 50% de desconto nas gerações na sua primeira assinatura',
        current_order: 'Assinatura atual',
        expiry_time: 'Data de expiração',
        monthly: 'Mensal',
        yearly: 'Anual',
        order_query_failed: 'Pedido de pagamento falhado,',
        order_query_failed_button: 'Clique para re-consultar',
        short_pay_type: 'Pagamento rápido',
        or: 'ou',
        month_half_price: 'Aproveite 50% de desconto na sua primeira geração com a primeira assinatura',
        year_half_price: 'Aproveite 50% de desconto nas suas primeiras 5 gerações com a primeira assinatura',
        shop: 'Loja',
        right_now_login: 'Entrar agora',
        login_to_use_more_features: 'Entre para usar mais recursos',
    },
    it: {
        change_plan: 'Cambiare il Piano',
        choose_order_type: 'Scegliere il Metodo di Pagamento',
        credit_card: 'Carta di Credito',
        card_notice:
            'Tutti i campi sono obbligatori, a meno che non siano indicati diversamente.',
        card_number: 'Numero della Carta',
        expiry_date: 'Data di Scadenza',
        cvv: 'Codice di Sicurezza',
        cardholder_name: 'Nome del Titolare del Carta',
        cardholder_name_notice:
            'Per favore, inserisci il nome del titolare del carta',
        pay_now: 'Paga Ora',
        processing: 'In elaborazione...',
        account: 'Account',
        product_name: 'Nome del Prodotto',
        paymentInformationIsSafe: 'La tua informazione di pagamento è sicura',
        cancelSubscription:
            'Puoi annullare la tua sottoscrizione in qualsiasi momento',
        pay_type_loading: 'Caricamento del metodo di pagamento...',
        order_content: 'Ordine di pagamento in attesa',
        pending_order_title: 'Hai un ordine in attesa di pagamento',
        pending_order_subtitle:
            'Si prega di pagare entro <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, verrà automaticamente annullato se scade',
        product: 'Prodotto:',
        original_price: 'Prezzo Originale:',
        now_price: 'Prezzo Attuale:',
        purchase_method: 'Metodo di Acquisto:',
        cancel: 'Annulla',
        continue_pay: 'Continua Pagamento',
        year_pay: 'Anno',
        monthly_pay: 'Mese',
        year_price: '/Anno',
        payment_information_is_safe:
            '微鲤AI si impegna a proteggere la sicurezza del suo pagamento',
        go_to_create: 'Vai a Creare',
        continue_chat: 'Continua Chat',
        pay_success: 'Pagamento Eseguito',
        pay_failed: 'Impossibile processare il pagamento',
        pay_failed_notice:
            "Per favore, prova con un'altra carta o usa un altro metodo di pagamento",
        change_payment_method: 'Cambiare Metodo di Pagamento',
        pending_order_content: 'Ordine di pagamento in attesa',
        expiry_date_placeholder: 'MM/AA',
        paypal: 'Paypal',
        bank_card_pay: 'Pagamento con Carta Bancaria',
        errorVideoUpscalerSizeExceeded:
            'La dimensione del video non può superare 100MB',
        videoUpscalerResolutionTooLow:
            'La risoluzione selezionata {target} non può essere minore della risoluzione originale del video {source}',
        first_pay_half_price:
            '🎉 50% di sconto sulle generazioni alla prima iscrizione',
        current_order: 'Abbonamento attuale',
        expiry_time: 'Data di scadenza',
        monthly: 'Mensile',
        yearly: 'Annuale',
        order_query_failed: 'Ordine di pagamento fallito,',
        order_query_failed_button: 'Clicca per ri-consultare',
        short_pay_type: 'Pagamento rapido',
        or: 'o',
        month_half_price: 'Sconto del 50% sulla prima generazione con il primo abbonamento',
        year_half_price: 'Sconto del 50% sulle prime 5 generazioni con il primo abbonamento',
        shop: 'Negozio',
        right_now_login: 'Accedi ora',
        login_to_use_more_features: 'Accedi per utilizzare più funzionalità',
    },
    ar: {
        change_plan: 'تغيير الخطة',
        choose_order_type: 'اختيار طريقة الدفع',
        credit_card: 'بطاقة ائتمان',
        card_notice: 'جميع الحقول مطلوبة، عدا الذكر الآخر.',
        card_number: 'رقم البطاقة',
        expiry_date: 'تاريخ الانتهاء',
        cvv: 'رمز الأمان',
        cardholder_name: 'اسم صاحب البطاقة',
        cardholder_name_notice: 'يرجى إدخال اسم صاحب البطاقة',
        pay_now: 'دفع الآن',
        processing: 'يتم التحميل...',
        account: 'الحساب',
        product_name: 'اسم المنتج',
        paymentInformationIsSafe: 'معلومات الدفع الخاصة بك آمنة',
        cancelSubscription: 'يمكنك إلغاء الاشتراك في أي وقت',
        pay_type_loading: 'تحميل طريقة الدفع...',
        order_content: 'طلب دفع في الانتظار',
        pending_order_title: 'لديك طلب دفع معلق',
        pending_order_subtitle:
            'يرجى الدفع خلال <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>، سيتم إلغاؤه تلقائياً إذا انتهت صلاحيته',
        product: 'المنتج:',
        original_price: 'السعر الأصلي:',
        now_price: 'السعر الحالي:',
        purchase_method: 'طريقة الشراء:',
        cancel: 'إلغاء',
        continue_pay: 'متابعة الدفع',
        year_pay: 'سنة',
        monthly_pay: 'شهر',
        year_price: '/سنة',
        payment_information_is_safe:
            '微鲤AI يتعهد بحماية الأمان الخاص بك في الدفع',
        go_to_create: 'الذهاب إلى إنشاء',
        continue_chat: 'متابعة الدردشة',
        pay_success: 'الدفع ناجح',
        pay_failed: 'غير قادر على معالجة الدفع',
        pay_failed_notice:
            'يرجى المحاولة مع بطاقة أخرى أو استخدام طريقة دفع أخرى',
        change_payment_method: 'تغيير طريقة الدفع',
        pending_order_content: 'طلب دفع في الانتظار',
        expiry_date_placeholder: 'شهر/سنة',
        paypal: 'Paypal',
        bank_card_pay: 'الدفع بالبطاقة المصرفية',
        errorVideoUpscalerSizeExceeded: 'حجم الفيديو لا يمكن أن يتجاوز 100MB',
        videoUpscalerResolutionTooLow:
            'الدقة المختارة {target} لا يمكن أن تكون أصغر من الدقة الأصلية للفيديو {source}',
        first_pay_half_price: '🎉 خصم 50٪ على الإنشاء عند الاشتراك لأول مرة',
        current_order: 'الاشتراك الحالي',
        expiry_time: 'تاريخ الانتهاء',
        monthly: 'شهري',
        yearly: 'سنوي',
        order_query_failed: 'طلب الدفع فشل,',
        order_query_failed_button: 'اضغط للاستفسار مرة أخرى',
        short_pay_type: 'دفع سريع',
        or: 'أو',
        month_half_price: 'استمتع بخصم 50٪ على الإنشاء الأول عند الاشتراك لأول مرة',
        year_half_price: 'استمتع بخصم 50٪ على الـ 5 إنشاءات الأولى عند الاشتراك لأول مرة',
        shop: 'متجر',
        right_now_login: 'تسجيل الدخول الآن',
        login_to_use_more_features: 'سجّل الدخول لاستخدام المزيد من الميزات',
    },
    th: {
        change_plan: 'เปลี่ยนแพ็กเกจ',
        choose_order_type: 'เลือกวิธีชำระเงิน',
        credit_card: 'บัตรเครดิต',
        card_notice: 'ทุกช่องจำเป็นต้องกรอก เว้นแต่มีการระบุเป็นอย่างอื่น',
        card_number: 'หมายเลขบัตร',
        expiry_date: 'วันหมดอายุ',
        cvv: 'CVV',
        cardholder_name: 'ชื่อผู้ถือบัตร',
        cardholder_name_notice: 'โปรดกรอกชื่อผู้ถือบัตร',
        pay_now: 'ชำระเงินตอนนี้',
        processing: 'กำลังประมวลผล...',
        account: 'บัญชี',
        product_name: 'ชื่อสินค้า',
        paymentInformationIsSafe: 'ข้อมูลการชำระเงินของคุณปลอดภัย',
        cancelSubscription: 'คุณสามารถยกเลิกการสมัครได้ทุกเมื่อ',
        pay_type_loading: 'กำลังโหลดวิธีชำระเงิน...',
        order_content: 'คำสั่งซื้อที่รอชำระเงิน',
        pending_order_title: 'คุณมีคำสั่งซื้อที่รอการชำระเงิน',
        pending_order_subtitle:
            'โปรดชำระภายใน <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span> หากเกินเวลาจะยกเลิกอัตโนมัติ',
        product: 'สินค้า:',
        original_price: 'ราคาเดิม:',
        now_price: 'ราคาปัจจุบัน:',
        purchase_method: 'วิธีการซื้อ:',
        cancel: 'ยกเลิก',
        continue_pay: 'ชำระต่อ',
        year_pay: 'รายปี',
        monthly_pay: 'รายเดือน',
        year_price: '/ปี',
        payment_information_is_safe:
            '微鲤AI มุ่งมั่นปกป้องความปลอดภัยการชำระเงินของคุณ',
        go_to_create: 'ไปสร้าง',
        continue_chat: 'แชทต่อ',
        pay_success: 'ชำระเงินสำเร็จ',
        pay_failed: 'ไม่สามารถดำเนินการชำระเงินได้',
        pay_failed_notice: 'โปรดลองใช้บัตรอื่นหรือวิธีชำระเงินอื่น',
        change_payment_method: 'เปลี่ยนวิธีชำระเงิน',
        pending_order_content: 'คำสั่งซื้อที่รอชำระเงิน',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'ชำระด้วยบัตรธนาคาร',
        errorVideoUpscalerSizeExceeded: 'ขนาดวิดีโอต้องไม่เกิน 100MB',
        videoUpscalerResolutionTooLow:
            'ความละเอียดที่เลือก {target} ต้องไม่ต่ำกว่าความละเอียดต้นฉบับ {source}',
        first_pay_half_price:
            '🎉ส่วนลด 50% สำหรับการสร้างในการสมัครสมาชิกครั้งแรก',
        current_order: 'การสมัครสมาชิกปัจจุบัน',
        expiry_time: 'วันหมดอายุ',
        monthly: 'รายเดือน',
        yearly: 'รายปี',
        order_query_failed: 'การสืบค้นคำสั่งซื้อล้มเหลว,',
        order_query_failed_button: 'คลิกเพื่อสืบค้นอีกครั้ง',
        short_pay_type: 'ชำระเงินด่วน',
        or: 'หรือ',
        month_half_price: 'สมัครครั้งแรกรับส่วนลด 50% สำหรับการสร้าง 1 ครั้งแรก',
        year_half_price: 'สมัครครั้งแรกรับส่วนลด 50% สำหรับการสร้าง 5 ครั้งแรก',
        shop: 'ร้านค้า',
        right_now_login: 'เข้าสู่ระบบตอนนี้',
        login_to_use_more_features: 'เข้าสู่ระบบเพื่อใช้ฟีเจอร์เพิ่มเติม',
    },
    da: {
        change_plan: 'Skift plan',
        choose_order_type: 'Vælg betalingsmetode',
        credit_card: 'Kreditkort',
        card_notice: 'Alle felter er påkrævet, medmindre andet er angivet.',
        card_number: 'Kortnummer',
        expiry_date: 'Udløbsdato',
        cvv: 'CVV',
        cardholder_name: 'Kortholders navn',
        cardholder_name_notice: 'Indtast kortholders navn',
        pay_now: 'Betal nu',
        processing: 'Behandler...',
        account: 'Konto',
        product_name: 'Produktnavn',
        paymentInformationIsSafe: 'Dine betalingsoplysninger er sikre',
        cancelSubscription: 'Du kan annullere dit abonnement når som helst',
        pay_type_loading: 'Indlæser betalingsmetode...',
        order_content: 'Afventende betaling',
        pending_order_title: 'Du har en ordre der afventer betaling',
        pending_order_subtitle:
            'Betal venligst inden for <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, ellers annulleres den automatisk',
        product: 'Produkt:',
        original_price: 'Oprindelig pris:',
        now_price: 'Nuværende pris:',
        purchase_method: 'Købsmetode:',
        cancel: 'Annuller',
        continue_pay: 'Fortsæt betaling',
        year_pay: 'Årligt',
        monthly_pay: 'Månedligt',
        year_price: '/år',
        payment_information_is_safe:
            '微鲤AI er forpligtet til at beskytte din betalings­sikkerhed',
        go_to_create: 'Gå til Opret',
        continue_chat: 'Fortsæt chat',
        pay_success: 'Betaling gennemført',
        pay_failed: 'Betalingen kunne ikke behandles',
        pay_failed_notice: 'Prøv et andet kort eller en anden betalingsmetode',
        change_payment_method: 'Skift betalingsmetode',
        pending_order_content: 'Afventende betaling',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Betaling med bankkort',
        errorVideoUpscalerSizeExceeded:
            'Videostørrelsen må ikke overstige 100MB',
        videoUpscalerResolutionTooLow:
            'Den valgte opløsning {target} må ikke være lavere end den oprindelige videopløsning {source}',
        first_pay_half_price:
            '🎉 50% rabat på generationer for førstegangs-abonnenter',
        current_order: 'Nuværende abonnement',
        expiry_time: 'Udløbsdato',
        monthly: 'Månedligt',
        yearly: 'Årligt',
        order_query_failed: 'Ordreforespørgsel mislykkedes,',
        order_query_failed_button: 'Klik for at forespørge igen',
        short_pay_type: 'Hurtig betaling',
        or: 'eller',
        month_half_price: 'Få 50% rabat på din første generation med første abonnement',
        year_half_price: 'Få 50% rabat på dine første 5 generationer med første abonnement',
        shop: 'Butik',
        right_now_login: 'Log ind nu',
        login_to_use_more_features: 'Log ind for at bruge flere funktioner',
    },
    no: {
        change_plan: 'Bytt plan',
        choose_order_type: 'Velg betalingsmetode',
        credit_card: 'Kredittkort',
        card_notice: 'Alle felt er påkrevd med mindre annet er angitt.',
        card_number: 'Kortnummer',
        expiry_date: 'Utløpsdato',
        cvv: 'CVV',
        cardholder_name: 'Kortholders navn',
        cardholder_name_notice: 'Vennligst oppgi kortholders navn',
        pay_now: 'Betal nå',
        processing: 'Behandler...',
        account: 'Konto',
        product_name: 'Produktnavn',
        paymentInformationIsSafe: 'Betalingsinformasjonen din er trygg',
        cancelSubscription: 'Du kan når som helst kansellere abonnementet',
        pay_type_loading: 'Laster betalingsmetode...',
        order_content: 'Ventende betalingsordre',
        pending_order_title: 'Du har en ordre som venter på betaling',
        pending_order_subtitle:
            'Betal innen <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, ellers blir den automatisk kansellert',
        product: 'Produkt:',
        original_price: 'Opprinnelig pris:',
        now_price: 'Nåværende pris:',
        purchase_method: 'Kjøpsmåte:',
        cancel: 'Avbryt',
        continue_pay: 'Fortsett betaling',
        year_pay: 'Årlig',
        monthly_pay: 'Månedlig',
        year_price: '/år',
        payment_information_is_safe:
            '微鲤AI er forpliktet til å beskytte betalingssikkerheten din',
        go_to_create: 'Gå til skap',
        continue_chat: 'Fortsett chat',
        pay_success: 'Betaling vellykket',
        pay_failed: 'Kunne ikke behandle betaling',
        pay_failed_notice: 'Prøv et annet kort eller en annen betalingsmetode',
        change_payment_method: 'Endre betalingsmetode',
        pending_order_content: 'Ventende betalingsordre',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Betaling med bankkort',
        errorVideoUpscalerSizeExceeded:
            'Videostørrelsen kan ikke overstige 100MB',
        videoUpscalerResolutionTooLow:
            'Den valgte oppløsningen {target} kan ikke være lavere enn original oppløsning {source}',
        first_pay_half_price:
            '🎉 50% rabatt på genereringer for førstegangsabonnenter',
        current_order: 'Nåværende abonnement',
        expiry_time: 'Utløpsdato',
        monthly: 'Månedlig',
        yearly: 'Årlig',
        order_query_failed: 'Ordreforespørsel mislyktes,',
        order_query_failed_button: 'Klikk for å forespørre på nytt',
        short_pay_type: 'Hurtigbetaling',
        or: 'eller',
        month_half_price: 'Få 50% rabatt på din første generering med første abonnement',
        year_half_price: 'Få 50% rabatt på dine første 5 genereringer med første abonnement',
        shop: 'Butikk',
        right_now_login: 'Logg inn nå',
        login_to_use_more_features: 'Logg inn for å bruke flere funksjoner',
    },
    nl: {
        change_plan: 'Plan wijzigen',
        choose_order_type: 'Kies betaalmethode',
        credit_card: 'Creditcard',
        card_notice: 'Alle velden zijn verplicht, tenzij anders aangegeven.',
        card_number: 'Kaartnummer',
        expiry_date: 'Vervaldatum',
        cvv: 'CVV',
        cardholder_name: 'Naam op kaart',
        cardholder_name_notice: 'Voer de naam op de kaart in',
        pay_now: 'Nu betalen',
        processing: 'Bezig met verwerken...',
        account: 'Account',
        product_name: 'Productnaam',
        paymentInformationIsSafe: 'Je betalingsinformatie is veilig',
        cancelSubscription: 'Je kunt je abonnement op elk moment opzeggen',
        pay_type_loading: 'Betaalmethode laden...',
        order_content: 'Openstaande betaling',
        pending_order_title:
            'Je hebt een bestelling die nog moet worden betaald',
        pending_order_subtitle:
            'Betaal binnen <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, anders wordt deze automatisch geannuleerd',
        product: 'Product:',
        original_price: 'Oorspronkelijke prijs:',
        now_price: 'Huidige prijs:',
        purchase_method: 'Aankoopmethode:',
        cancel: 'Annuleren',
        continue_pay: 'Doorgaan met betalen',
        year_pay: 'Jaarlijks',
        monthly_pay: 'Maandelijks',
        year_price: '/jaar',
        payment_information_is_safe:
            '微鲤AI zet zich in voor de veiligheid van je betaling',
        go_to_create: 'Ga naar creëren',
        continue_chat: 'Chat voortzetten',
        pay_success: 'Betaling geslaagd',
        pay_failed: 'Betaling kon niet worden verwerkt',
        pay_failed_notice: 'Probeer een andere kaart of betaalmethode',
        change_payment_method: 'Betaalmethode wijzigen',
        pending_order_content: 'Openstaande betaling',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Betalen met bankkaart',
        errorVideoUpscalerSizeExceeded:
            'Videogrootte mag niet groter zijn dan 100MB',
        videoUpscalerResolutionTooLow:
            'De gekozen resolutie {target} mag niet lager zijn dan de oorspronkelijke videoresolutie {source}',
        first_pay_half_price:
            '🎉 50% korting op generaties voor eerste abonnees',
        current_order: 'Huidig abonnement',
        expiry_time: 'Vervaldatum',
        monthly: 'Maandelijks',
        yearly: 'Jaarlijks',
        order_query_failed: 'Orderopvraag mislukt,',
        order_query_failed_button: 'Klik om opnieuw te vragen',
        short_pay_type: 'Snelle betaling',
        or: 'of',
        month_half_price: 'Ontvang 50% korting op je eerste generatie bij eerste abonnement',
        year_half_price: 'Ontvang 50% korting op je eerste 5 generaties bij eerste abonnement',
        shop: 'Winkel',
        right_now_login: 'Nu inloggen',
        login_to_use_more_features: 'Log in om meer functies te gebruiken',
    },
    id: {
        change_plan: 'Ubah paket',
        choose_order_type: 'Pilih metode pembayaran',
        credit_card: 'Kartu kredit',
        card_notice: 'Semua kolom wajib diisi kecuali dinyatakan lain.',
        card_number: 'Nomor kartu',
        expiry_date: 'Tanggal kedaluwarsa',
        cvv: 'CVV',
        cardholder_name: 'Nama pemegang kartu',
        cardholder_name_notice: 'Masukkan nama pemegang kartu',
        pay_now: 'Bayar sekarang',
        processing: 'Memproses...',
        account: 'Akun',
        product_name: 'Nama produk',
        paymentInformationIsSafe: 'Informasi pembayaran Anda aman',
        cancelSubscription: 'Anda dapat membatalkan langganan kapan saja',
        pay_type_loading: 'Memuat metode pembayaran...',
        order_content: 'Pesanan menunggu pembayaran',
        pending_order_title: 'Anda memiliki pesanan yang menunggu pembayaran',
        pending_order_subtitle:
            'Silakan bayar dalam <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span>, akan dibatalkan otomatis jika terlambat',
        product: 'Produk:',
        original_price: 'Harga asli:',
        now_price: 'Harga sekarang:',
        purchase_method: 'Metode pembelian:',
        cancel: 'Batal',
        continue_pay: 'Lanjutkan pembayaran',
        year_pay: 'Tahunan',
        monthly_pay: 'Bulanan',
        year_price: '/tahun',
        payment_information_is_safe:
            '微鲤AI berkomitmen melindungi keamanan pembayaran Anda',
        go_to_create: 'Ke Buat',
        continue_chat: 'Lanjutkan chat',
        pay_success: 'Pembayaran berhasil',
        pay_failed: 'Tidak dapat memproses pembayaran',
        pay_failed_notice:
            'Coba kartu lain atau gunakan metode pembayaran lain',
        change_payment_method: 'Ubah metode pembayaran',
        pending_order_content: 'Pesanan menunggu pembayaran',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Bayar dengan kartu bank',
        errorVideoUpscalerSizeExceeded:
            'Ukuran video tidak boleh melebihi 100MB',
        videoUpscalerResolutionTooLow:
            'Resolusi yang dipilih {target} tidak boleh lebih rendah dari resolusi video asli {source}',
        first_pay_half_price:
            '🎉 Diskon 50% untuk pembuatan pertama bagi pelanggan baru',
        current_order: 'Langganan saat ini',
        expiry_time: 'Tanggal kedaluwarsa',
        monthly: 'Bulanan',
        yearly: 'Tahunan',
        order_query_failed: 'Gagal mengambil pesanan,',
        order_query_failed_button: 'Klik untuk mencoba lagi',
        short_pay_type: 'Pembayaran cepat',
        or: 'atau',
        month_half_price: 'Nikmati diskon 50% untuk pembuatan pertama dengan langganan pertama',
        year_half_price: 'Nikmati diskon 50% untuk 5 pembuatan pertama dengan langganan pertama',
        shop: 'Toko',
        right_now_login: 'Masuk sekarang',
        login_to_use_more_features: 'Masuk untuk menggunakan lebih banyak fitur',
    },
    tr: {
        change_plan: 'Planı değiştir',
        choose_order_type: 'Ödeme yöntemi seç',
        credit_card: 'Kredi kartı',
        card_notice: 'Aksi belirtilmedikçe tüm alanlar zorunludur.',
        card_number: 'Kart numarası',
        expiry_date: 'Son kullanma tarihi',
        cvv: 'CVV',
        cardholder_name: 'Kart sahibinin adı',
        cardholder_name_notice: 'Lütfen kart sahibinin adını girin',
        pay_now: 'Şimdi öde',
        processing: 'İşleniyor...',
        account: 'Hesap',
        product_name: 'Ürün adı',
        paymentInformationIsSafe: 'Ödeme bilgileriniz güvende',
        cancelSubscription:
            'Aboneliğinizi istediğiniz zaman iptal edebilirsiniz',
        pay_type_loading: 'Ödeme yöntemi yükleniyor...',
        order_content: 'Ödeme bekleyen sipariş',
        pending_order_title: 'Ödeme bekleyen bir siparişiniz var',
        pending_order_subtitle:
            'Lütfen <span class="inline-block w-4">{time_1}</span>:<span class="inline-block w-4">{time_2}</span> içinde ödeme yapın, süre aşılırsa otomatik olarak iptal edilir',
        product: 'Ürün:',
        original_price: 'Orijinal fiyat:',
        now_price: 'Güncel fiyat:',
        purchase_method: 'Satın alma yöntemi:',
        cancel: 'İptal',
        continue_pay: 'Ödemeye devam et',
        year_pay: 'Yıllık',
        monthly_pay: 'Aylık',
        year_price: '/yıl',
        payment_information_is_safe:
            '微鲤AI ödeme güvenliğinizi korumayı taahhüt eder',
        go_to_create: 'Oluşturmaya git',
        continue_chat: 'Sohbete devam et',
        pay_success: 'Ödeme başarılı',
        pay_failed: 'Ödeme işlenemedi',
        pay_failed_notice:
            'Lütfen başka bir kart deneyin veya farklı bir ödeme yöntemi kullanın',
        change_payment_method: 'Ödeme yöntemini değiştir',
        pending_order_content: 'Ödeme bekleyen sipariş',
        expiry_date_placeholder: 'MM/YY',
        paypal: 'Paypal',
        bank_card_pay: 'Banka kartı ile ödeme',
        errorVideoUpscalerSizeExceeded: "Video boyutu 100MB'ı aşamaz",
        videoUpscalerResolutionTooLow:
            'Seçilen çözünürlük {target}, orijinal video çözünürlüğü {source} değerinden düşük olamaz',
        first_pay_half_price:
            '🎉 İlk kez abone olanlar için üretimlerde %50 indirim',
        current_order: 'Mevcut abonelik',
        expiry_time: 'Son kullanma tarihi',
        monthly: 'Aylık',
        yearly: 'Yıllık',
        order_query_failed: 'Sipariş sorgusu başarısız,',
        order_query_failed_button: 'Tekrar sorgulamak için tıklayın',
        short_pay_type: 'Hızlı ödeme',
        or: 'veya',
        month_half_price: 'İlk abonelikte ilk 1 üretimde %50 indirim',
        year_half_price: 'İlk abonelikte ilk 5 üretimde %50 indirim',
        shop: 'Mağaza',
        right_now_login: 'Şimdi giriş yap',
        login_to_use_more_features: 'Daha fazla özellik kullanmak için giriş yapın',
    },
}
